import { api } from '../api';

export const CODES_ENDPOINTS = Object.freeze({
  check: (code: string) => api.get(`/codes/check/${code}`),
});
